"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var popoverTransitionDuration = { exit: 0, enter: 200 };
exports.default = popoverTransitionDuration;
